/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import Map from "./Map.jsx";

function RowDataTable({
                          iconName,
                          onRowClicked,
                          onMiddleMouseClick,
                          buttons,
                          emptyState,
                          iconElement,
                          selectedIndex = -1,
                          data
                      }) {


    return (<div>
        <Map lines={data} chunkSize={50}>
            {(row, index) => {


                let isSelected = selectedIndex === index

                return (<div
                    key={row.indexKey}
                    className={`h-12 hover:bg-stone-50 rounded-sm flex items-center p-2 cursor-pointer border border-stone-200 transition-colors duration-200 group mb-2`}
                    onClick={(event) => {
                        if (onRowClicked !== undefined) {
                            onRowClicked(row)
                        }
                    }}
                    onMouseDown={(event) => {
                        // on middle mouse click
                        if (event.button === 1) {
                            if (onMiddleMouseClick !== undefined) {
                                onMiddleMouseClick(row, event)
                            }
                        }
                    }}
                >

                    {iconElement ? iconElement(row) : ""}

                    {iconName && (<div className={"ml-1 mr-3 "}>
                        <DisplayIcon iconName={iconName}/>
                    </div>)}


                    <div className={"flex flex-col text-sm w-96"}>
                        <div className={"font-semibold text-gray-600 truncate"}>
                            {row.Name}
                        </div>
                        <div className={"text-xs text-gray-400 truncate"}>
                            {row.Description}
                        </div>
                    </div>

                    <div className={"grow"}></div>
                    <div
                        className={"hidden sm:flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300 focus-within:opacity-100"}>
                        {buttons !== undefined && buttons(row)}

                    </div>

                </div>)
            }}

        </Map>
        {(data.length === 0 && emptyState !== undefined) && (<>
            {emptyState()}

        </>)}


    </div>)

}


RowDataTable.propTypes = {};

export default RowDataTable;